/** @jsxImportSource @emotion/react */
import React from 'react';
import { Row, Col, Space, Card, Tooltip } from 'antd';
import { PageContentLayout, PageHeaderLayout } from '../../../shared/layout';
import { QuestionCircleOutlined } from '@ant-design/icons';
import CustomRangePicker from '../../../shared/dates/CustomRangePicker';
import RollUpDisplay from './display';
import RollUpPaidSearch from './paid-search';
import {
  formatCurrency2SigFig,
  formatNumber,
  formatNumber3SigFig,
} from '../../../../core/utils/campaigns';
import RollUpSEO from './SEO';
// import SelectAdvertiser from "./components/SelectAdvertiser";
import RollUpSelector from './components/RollUpSelector';
import AdvertiserFilter from '../../../shared/AdvertiserFilter';
import './styles/index.css';
import '../../../shared/globalStyling/responsive.css';
import { orgLevelCustomization } from '../../../../core/permissions/orgLevelCustomization';

const RollUpMainView = ({
  startDateEndDate,
  setStartDateEndDate,
  dateRangeKey,
  setDateRangeKey,
  orgsList,
  filteredOrg,
  setLoadProgress,
  loadProgress,
  totals,
  setTotals,
  startDate,
  endDate,
  productOn,
  setProductOn,
  userPermission,
  hasFeaturePaidSearch,
  hasFeatureSEO,
  currentUser,
}) => {
  const orgCustomization = orgLevelCustomization(currentUser.role.org.dataConfig || {});
  const { currencyFormat, roasFormat } = orgCustomization;
  
  return (
    <div className="modern-ui-scope">
      <PageHeaderLayout
   rightContent={
  <div
    style={{
      background: 'var(--mj-surface)',
      width: '100%',
      padding: '16px 24px',
      boxShadow: 'var(--mj-shadow-sm)',
      borderBottom: '1px solid var(--mj-border)',
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <Row
      align="middle"
      justify="space-between"
      style={{ width: '100%', maxWidth: '1400px' }}
      gutter={[16, 16]}
      id="roll-up-filters"
    >
      {/* Tooltip + Roll-Up Selector */}
      <Col xs={24} sm={24} md={8} lg={6}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Tooltip
            placement="bottom"
            title="Date Picker: Filters campaigns whose flight dates overlap the selected range, and shows only data within that range."
          >
            <QuestionCircleOutlined
              style={{
                color: 'var(--mj-text-secondary)',
                fontSize: 16,
                cursor: 'pointer',
              }}
            />
          </Tooltip>
          <RollUpSelector
            productOn={productOn}
            setProductOn={setProductOn}
            hasFeaturePaidSearch={hasFeaturePaidSearch}
            hasFeatureSEO={hasFeatureSEO}
          />
        </div>
      </Col>

      {/* Advertiser Filter */}
      <Col xs={24} sm={24} md={8} lg={6}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          {orgsList && <AdvertiserFilter />}
        </div>
      </Col>

      {/* Date Range Picker */}
      <Col xs={24} sm={24} md={8} lg={6}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <CustomRangePicker
            value={startDateEndDate}
            defaultValue={startDateEndDate}
            onChange={setStartDateEndDate}
            rangeKey={dateRangeKey}
            setRangeKey={setDateRangeKey}
          />
        </div>
      </Col>
    </Row>
  </div>
}

    
    
    />
      <PageContentLayout>
        <Space size={24} style={{ width: '100%' }} direction="vertical">
          {/* Modern Metric Cards - Optimized Breakpoint Strategy */}
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={12} md={12} lg={12} xl={6}>
              <Card className="metric-card" bodyStyle={{ padding: '24px' }}>
                <div className="metric-value">
                  {totals.impressions ? formatNumber(totals.impressions) : 'N/A'}
                </div>
                <div className="metric-label">Impressions Served</div>
              </Card>
            </Col>
            {userPermission && userPermission.priceVisible && (
              <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                <Card className="metric-card" bodyStyle={{ padding: '24px' }}>
                  <div className="metric-value">
                    {totals.spend ? formatCurrency2SigFig(totals.spend, currencyFormat) : 'N/A'}
                  </div>
                  <div className="metric-label">Budget Spent</div>
                </Card>
              </Col>
            )}
            {totals.hasEcommerceAttribution && (
              <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                <Card className="metric-card" bodyStyle={{ padding: '24px' }}>
                  <div className="metric-value">
                    {totals.revenue ? formatCurrency2SigFig(totals.revenue, currencyFormat) : 'N/A'}
                  </div>
                  <div className="metric-label">Revenue</div>
                </Card>
              </Col>
            )}
            {userPermission && userPermission.priceVisible && totals.hasEcommerceAttribution && (
              <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                <Card className="metric-card" bodyStyle={{ padding: '24px' }}>
                  <div className="metric-value">
                    {totals.roas ? formatNumber3SigFig(totals.roas) + '%' : 'N/A'}
                  </div>
                  <div className="metric-label">ROAS</div>
                </Card>
              </Col>
            )}
          </Row>
          {productOn.display && (
            <Row gutter={[16, 16]}>
              <Col flex="auto">
                <RollUpDisplay
                  productOn={productOn}
                  setTotals={setTotals}
                  totals={totals}
                  startDate={startDate}
                  endDate={endDate}
                  loadProgress={loadProgress}
                  setLoadProgress={setLoadProgress}
                  currencyFormat={currencyFormat}
                />
              </Col>
            </Row>
          )}
          {productOn.sem && (
            <Row gutter={[16, 16]}>
              <Col flex="auto">
                <RollUpPaidSearch
                  productOn={productOn}
                  setTotals={setTotals}
                  totals={totals}
                  startDate={startDate}
                  filteredOrg={filteredOrg}
                  endDate={endDate}
                  loadProgress={loadProgress}
                  setLoadProgress={setLoadProgress}
                  currencyFormat={currencyFormat}
                  roasFormat={roasFormat}
                />
              </Col>
            </Row>
          )}
          {productOn.seo && (
            <Row gutter={[16, 16]}>
              <Col flex="auto">
                <RollUpSEO
                  productOn={productOn}
                  setTotals={setTotals}
                  totals={totals}
                  startDate={startDate}
                  endDate={endDate}
                  loadProgress={loadProgress}
                  setLoadProgress={setLoadProgress}
                  currencyFormat={currencyFormat}
                />
              </Col>
            </Row>
          )}
        </Space>
      </PageContentLayout>
    </div>
  );
};

export default RollUpMainView;
